var _searchJustOpened = false;

function openSearch() {
  var modal = document.getElementById('searchModal');
  if (!modal) return;
  _searchJustOpened = true;
  if (modal.parentNode !== document.body) document.body.appendChild(modal);
  modal.classList.add('is-open');
  var input = modal.querySelector('.search-modal-input');
  if (input) setTimeout(function() { input.focus(); }, 50);
  document.body.style.overflow = 'hidden';
}

function closeSearch() {
  var modal = document.getElementById('searchModal');
  if (!modal) return;
  modal.classList.remove('is-open');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeSearch();
});

document.addEventListener('click', function(e) {
  if (_searchJustOpened) { _searchJustOpened = false; return; }
  var modal = document.getElementById('searchModal');
  if (!modal || !modal.classList.contains('is-open')) return;
  var box = modal.querySelector('.search-modal-box');
  if (box && !box.contains(e.target)) closeSearch();
});
